import React, { useCallback, useEffect, useState } from "react";
import InternshipTiles from "./InternshipTiles";
import FilterDropdowns from "../../components/FilterDropdowns/FilterDropdowns";
import "../TalkToAnExpert/TalkToAnExpert.css";
import "../ExploreCareers/ExploreCareers.css";
import "./FindInternshipstyle.css";
import { filterInternshipsEventBuilder, sendEvent } from "../../utils/event-helpers";
import { fetchResourceTilesByTagFilters, TaggedResourceTiles } from "../../utils/contentful-helpers";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { markRecommendationFiltersAdjusted } from "../../stores/recommendations/mentorRecommendationsSlice";
import { RecommenderOutletContext } from "../RecommenderPage/RecommenderPage";
import { useOutletContext } from "react-router-dom";

const FindInternships = () => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<TaggedResourceTiles[]>([]);
  const { pageFilters, setPageFilters } = useOutletContext<RecommenderOutletContext>();
  
  const selectedSubfields = pageFilters.findInternships.subfields;

  const { userId, sessionId } = useAppSelector((state) => state.session);
  const recommendations = useAppSelector((state) => state.mentorRecommendations.data);
  const dispatch = useAppDispatch();

  const updateFindInternshipsFilters = useCallback((subfields: string[]) => {
    setPageFilters((prev) => ({
      ...prev,
      findInternships: { subfields },
    }));
  }, [setPageFilters]);

  const filteredResourceTiles = taggedResourceTiles.map((group) => {
    if (selectedSubfields.length === 0) {
      return group;
    }

    return {
      ...group,
      data: group.data.filter((tile) => {
        const keywords = tile.data.keyword || [];

        const matchesSubfield =
          selectedSubfields.length > 0
            ? selectedSubfields.some((sub) => keywords.includes(sub))
            : true;

        return matchesSubfield;
      }),
    };
  });
  
  useEffect(() => {
    if (!recommendations) return;
    if (recommendations.recommendedFilters.adjusted) return;

    updateFindInternshipsFilters(recommendations.recommendedFilters.subFields)
  }, [recommendations, updateFindInternshipsFilters])

  useEffect(() => {
    const tagFilters = ["Internship General Resources", "Internship Additional Resources"];
    fetchResourceTilesByTagFilters(tagFilters).then((results) => {
      setTaggedResourceTiles(results);
    });
  }, []);

  useEffect(() => {
    const allFilteredTiles = filteredResourceTiles.map(tile => tile.data).flat();
    const allTileTitles = allFilteredTiles.map(tile => tile.title);

    const eventData = filterInternshipsEventBuilder(userId, sessionId, allTileTitles, {
      subfieldsFilter: selectedSubfields,
    });

    sendEvent(eventData);
  }, [userId, sessionId, selectedSubfields, filteredResourceTiles])

  const handleSubfieldsChange = (subfields: string[]) => {
    dispatch(markRecommendationFiltersAdjusted());
    updateFindInternshipsFilters(subfields);
  };

  const handleClearFilters = () => {
    dispatch(markRecommendationFiltersAdjusted());
    updateFindInternshipsFilters([]);
  };

  return (
    <>
      <div className="explore-careers">
        <div className="resources-container">
          <div className="align-headers">
            <div>
              <p
                className="career-highlighted-paragraph"
                style={{ paddingBottom: "14px", marginTop: "17px" }}
              >
                Internship Resources
                <span style={{ marginRight: "15.5rem" }}></span>
              </p>
            </div>
            <div className="align-input">
              <div className="dropdown-list">
                <FilterDropdowns
                  showSubfield={true}
                  selectedSubfields={selectedSubfields}
                  onSubfieldsChange={handleSubfieldsChange}
                  onClear={handleClearFilters}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        {filteredResourceTiles.map(tile => (
          <InternshipTiles
            key={tile.tagFilter}
            resourceTiles={tile.data}
          />
        ))}
      </div>
    </>
  );
};

export default FindInternships;
